import type { CSSProperties, ReactElement, ReactNode } from "react";
import { space } from "@tokens/index";
import { PageHeader } from "@compositions/index";

/**
 * SettingsPage: the content column of one settings category.
 *
 * `SettingsLayout` owns the chrome, the nav, and the column width. This
 * component stacks the page header and its groups.
 */

interface SettingsPageProps {
    readonly title: string;
    readonly description?: string;
    readonly children: ReactNode;
}

const pageStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    gap: space[6],
    width: "100%",
    minWidth: 0,
};

export function SettingsPage({ title, description, children }: SettingsPageProps): ReactElement {
    return (
        <div style={pageStyle}>
            <PageHeader title={title} {...(description !== undefined ? { description } : {})} />
            {children}
        </div>
    );
}
